/* @ngInject */

export default (
  FundingWorksheetFundsRequiredSplit,
  FundingWorksheetFundsAvailableSplit
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FundingWorksheet(fundsRequired, fundsAvailable, fundsTotal, isEdit) {
    this.fundsRequired = fundsRequired;
    this.fundsAvailable = fundsAvailable;
    this.fundsTotal = fundsTotal;
    this.isEdit = isEdit;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheet.Blank = function () {
    return FundingWorksheet.Build({
      fundsRequired: [],
      fundsAvailable: [],
      fundsTotal: {
        required: 0,
        available: 0,
        difference: 0
      },
      isEdit: false
    });
  };
  FundingWorksheet.Build = function (data) {
    return new FundingWorksheet(
      _.map(_.compact(data.fundsRequired), (fundRequired) =>
        FundingWorksheetFundsRequiredSplit.Build(fundRequired)
      ),
      _.map(_.compact(data.fundsAvailable), (fundAvailable) =>
        FundingWorksheetFundsAvailableSplit.Build(fundAvailable)
      ),
      data.fundsTotal
        ? data.fundsTotal
        : {
            required: 0,
            available: 0,
            difference: 0
          },
      data.isEdit ? data.isEdit : false
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheet.prototype.deleteDateObject = function () {
    for (let f = 0; f < this.fundsRequired.length; f += 1) {
      delete this.fundsRequired[f].contractDateObject;
    }
  };

  return FundingWorksheet;
};
